import { render } from "./TableRow.vue?vue&type=template&id=9dcd52b4&scoped=true"
import script from "./TableRow.vue?vue&type=script&lang=ts"
export * from "./TableRow.vue?vue&type=script&lang=ts"

import "./TableRow.vue?vue&type=style&index=0&id=9dcd52b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9dcd52b4"

export default script